import { TableCellTypes, TypographyWeights } from '@carboledger/ui';
import { CellText, makeViewBtnCell, makeSerialCell } from '@/components/common';
import { buildAccessStatusVariants } from './accessStatus';
import { ACCESS_STATUS_TONE } from './adminTones';
import { SITE_ACCESS_COLUMNS, USER_COLUMNS, USER_SORT_FIELDS } from './admin.constants';

const canSort = (id) => Boolean(USER_SORT_FIELDS[id]);

const renderUserName = (ctx) => (
  <CellText truncate weight={TypographyWeights.semibold}>
    {ctx.value}
  </CellText>
);

// A super admin reaches every site, so the design prints that instead of a View link.
const makeSiteAccessCell = (t, onViewAccess) => {
  const renderView = makeViewBtnCell(onViewAccess);
  const renderAccess = (ctx) =>
    ctx.row.hasAllSites ? <CellText>{t('ADMIN_ALL_SITES')}</CellText> : renderView(ctx);
  return renderAccess;
};

export const buildAccessManagerColumns = (t, { serialOffset = 0, onViewAccess }) =>
  [
    {
      id: USER_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 100,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: USER_COLUMNS.userName,
      header: t('FIELD_USER_NAME'),
      type: TableCellTypes.custom,
      width: 280,
      cell: renderUserName,
    },
    {
      id: USER_COLUMNS.accessType,
      header: t('FIELD_ACCESS_TYPE'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: USER_COLUMNS.siteAccess,
      header: t('FIELD_SITES_STORAGE_ACCESS'),
      type: TableCellTypes.custom,
      width: 200,
      cell: makeSiteAccessCell(t, onViewAccess),
    },
    {
      id: USER_COLUMNS.status,
      header: t('FIELD_STATUS'),
      type: TableCellTypes.statusDot,
      width: 200,
      variantMap: buildAccessStatusVariants(t, ACCESS_STATUS_TONE),
    },
    {
      id: USER_COLUMNS.lastActive,
      header: t('FIELD_LAST_ACTIVE'),
      type: TableCellTypes.date,
      width: 200,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));

// The modal holds every row at once, so it sorts client-side and every column is sortable.
export const buildSiteAccessColumns = (t) => [
  {
    id: SITE_ACCESS_COLUMNS.serialNo,
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 80,
    sortable: true,
  },
  {
    id: SITE_ACCESS_COLUMNS.name,
    header: t('FIELD_SITE_STORAGE_NAME'),
    type: TableCellTypes.text,
    sortable: true,
  },
  {
    id: SITE_ACCESS_COLUMNS.code,
    header: t('FIELD_ID'),
    type: TableCellTypes.text,
    width: 140,
    sortable: true,
  },
];
